(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let lastActionButton = null;
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.product-form__submit, .quick-add__submit');
    if (!button || button.disabled) return;
    lastActionButton = button;
    if (reduceMotion) return;
    button.classList.remove('slv-tap');
    requestAnimationFrame(() => button.classList.add('slv-tap'));
    window.setTimeout(() => button.classList.remove('slv-tap'), 220);
  }, { passive: true });

  if (typeof subscribe === 'function') {
    subscribe('cart-update', (payload) => {
      if (!payload || !['product-form', 'quick-add'].includes(payload.source) || !lastActionButton) return;
      const button = lastActionButton;
      const label = button.querySelector('span');
      if (!label) return;
      const originalLabel = label.textContent;
      label.textContent = '✓ Added to Cart';
      button.classList.add('slv-added');
      window.setTimeout(() => {
        if (!label.isConnected) return;
        label.textContent = originalLabel;
        button.classList.remove('slv-added');
      }, 1500);
      lastActionButton = null;
    });
  }
})();
